export default {
  login ({ commit }, name) {
    commit('setName', name)
  },

  logout: ({ commit }) => {
    commit('RESET', '')
  }

}



// WEBPACK FOOTER //
// ./src/store/actions.js